import React from "react";
import { Button } from "@/components/ui/button";
import { SelectWithOptions } from "@/components/SelectWithOptions/SelectWithOptions";

interface SelectOption {
  value: string;
  label: string;
}

interface PeriodSelectorProps {
  startKey: string;
  endKey: string;
  onStartKeyChange: (key: string) => void;
  onEndKeyChange: (key: string) => void;
  startMonthOptions: SelectOption[];
  endMonthOptions: SelectOption[];
  resolvedRange: string;
  onGenerateReport: () => void;
  canGenerate: boolean;
  loading: boolean;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  startKey,
  endKey,
  onStartKeyChange,
  onEndKeyChange,
  startMonthOptions,
  endMonthOptions,
  resolvedRange,
  onGenerateReport,
  canGenerate,
  loading,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-center gap-3">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
            Start
          </label>
          <div className="flex-1">
            <SelectWithOptions
              onValueChange={onStartKeyChange}
              options={startMonthOptions}
              value={startKey}
            />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
            End
          </label>
          <div className="flex-1">
            <SelectWithOptions
              onValueChange={onEndKeyChange}
              options={endMonthOptions}
              value={endKey}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between gap-4 flex-wrap">
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
          {resolvedRange}
        </p>
        <Button
          disabled={!canGenerate || loading}
          onClick={onGenerateReport}
          type="button"
        >
          {loading ? "Generating..." : "Generate Report"}
        </Button>
      </div>
    </div>
  );
};
